import {css} from "@emotion/react";

export const tdaMobileImageHolder = css`
    width: 375px;
    max-width: 100%;
    height: 100%;
    max-height: 484px;
`;
import {css} from "@emotion/react";

export const tdaMobileImageHolder = css`
    width: 375px;
    max-width: 100%;
    height: 100%;
    max-height: 484px;
`;
